import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthSplitLayout } from 'src/layouts/auth-split';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

/** **************************************
 * AUTH ROUTES
 *************************************** */

const SignInPage = lazy(() => import('src/pages/auth/sign-in'));
const SignUpPage = lazy(() => import('src/pages/auth/sign-up'));
const ResetPasswordPage = lazy(() => import('src/pages/auth/reset-password'));
const UpdatePasswordPage = lazy(() => import('src/pages/auth/update-password'));
const VerifyPage = lazy(() => import('src/pages/auth/verify'));

const auth = [
  {
    path: 'sign-in',
    element: (
      <GuestGuard>
        <AuthSplitLayout
          section={{
            title: 'Hi, Welcome back',
          }}
        >
          <SignInPage />
        </AuthSplitLayout>
      </GuestGuard>
    ),
  },
  {
    path: 'sign-up',
    element: (
      <GuestGuard>
        <AuthSplitLayout>
          <SignUpPage />
        </AuthSplitLayout>
      </GuestGuard>
    ),
  },
  {
    path: 'reset-password',
    element: (
      <GuestGuard>
        <AuthSplitLayout>
          <ResetPasswordPage />
        </AuthSplitLayout>
      </GuestGuard>
    ),
  },
  {
    path: 'update-password',
    element: (
      <GuestGuard>
        <AuthSplitLayout>
          <UpdatePasswordPage />
        </AuthSplitLayout>
      </GuestGuard>
    ),
  },
  {
    path: 'verify',
    element: (
      <GuestGuard>
        <AuthSplitLayout>
          <VerifyPage />
        </AuthSplitLayout>
      </GuestGuard>
    ),
  },
];

// ----------------------------------------------------------------------

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: auth,
  },
];
